// extracted by mini-css-extract-plugin
export default {"Reports":"styles_Reports__dRBaJ"};